import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { ButtonComponent } from "./shared/components/button/button.component";
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../environments/environment';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonComponent, TranslateModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  showTokenPopup = false;
  countdown: number = 0;
  intervalId: any;
  countdownMinutes: number = 0;
  countdownSeconds: number = 0;
  private copyListener?: (e: Event) => void;
  private cutListener?: (e: Event) => void;
  private contextMenuListener?: (e: Event) => void;

  // This method is used to initialize the class instance using auth
  constructor(
    private auth: AuthService,
  ) {

  }
  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    // show session expiry timer
    // if (this.auth.isLoggedIn()) {
    //   this.startTokenCountdown();
    // }

    // Conditionally disable copy/cut across the application
    if (environment.disableCopy) {
      // This method is used to register copy listener callback using e
      this.copyListener = (e: Event) => {
        e.preventDefault();
      };
      // This method is used to register cut listener callback using e
      this.cutListener = (e: Event) => {
        e.preventDefault();
      };
      // This method is used to register context menu listener callback using e
      this.contextMenuListener = (e: Event) => {
        e.preventDefault();
      };
      document.addEventListener('copy', this.copyListener);
      document.addEventListener('cut', this.cutListener);
      document.addEventListener('contextmenu', this.contextMenuListener);

      // Disable text selection via CSS class on body
      // document.body.classList.add('app-no-select');
    }
  }
  // This method is used to start token countdown
  startTokenCountdown() {
    // clear any existing interval before starting a new one
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    const expiresAt = this.auth['oauthService'].getAccessTokenExpiration();
    this.countdown = Math.floor((expiresAt - Date.now()) / 1000);

    this.updateCountdownDisplay();

    this.intervalId = setInterval(() => {
      this.countdown--;

      this.updateCountdownDisplay();

      // Show popup when less than or equal to 16 minutes
      if (this.countdown <= 960 && !this.showTokenPopup) {
        this.showTokenPopup = true;
      }

      // Logout when token expires
      if (this.countdown <= 0) {
        clearInterval(this.intervalId);
        this.auth.logout();
      }
    }, 1000);
  }


  // This method is used to update countdown display
  updateCountdownDisplay() {
    this.countdownMinutes = Math.floor(this.countdown / 60);
    this.countdownSeconds = this.countdown % 60;
  }
  // This method is used to refresh manually
  refreshManually() {
    this.showTokenPopup = false;
    // stop current countdown
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.auth.refreshToken();
    setTimeout(() => {
      this.startTokenCountdown(); // reset countdown
    }, 2000);
  }

  // This method is used to log out now
  logoutNow() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.auth.logout();

  }

  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.copyListener) {
      document.removeEventListener('copy', this.copyListener);
    }
    if (this.cutListener) {
      document.removeEventListener('cut', this.cutListener);
    }
    if (this.contextMenuListener) {
      document.removeEventListener('contextmenu', this.contextMenuListener);
    }
    document.body.classList.remove('app-no-select');
  }
}
